<template>
	<div>
	    <form action="" method="POST">
			<div class="row">
	        	<div class="col">
	                <div class="form-group row">
	                    <label for="comment" class="col-md-2 col-form-label text-right">Comments</label>
	                    <div class="col-md-10">
	                        <textarea 
		                        class="form-control" 
		                        rows="10"
		                        id="comment" 
		                        name="comment" 
		                        placeholder="No personally identifiable information" 
		                        :value="generalComment.comment"
		                        @change="updateGeneralComment($event)"
	                        ></textarea>
	                    </div>
	                </div><!-- .form-group -->
	            </div><!-- .col -->
	        </div><!-- .row -->

	        <div class="form-group row mb-0">
                <div class="col-md-10 offset-md-2">
		            <a id="general_comment_save" href="#" class="btn btn-primary ml-4">Save</a> 
		            <span v-if="submitSuccess" id="form_saved" class="ml-4"><i>saved {{ generalComment.updated_at }}</i></span>
		        </div>
		    </div>
	    </form>
	</div>
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'

    export default {
        name: "General Comment",

        components: { },

        props: {
            assessmentCycle: Object,
            assessmentType: String
        },

        data() {
            return {
                cycleStage: this.$options.name
            }       
         },

        methods: {
        	updateGeneralComment (e) {
        		let data = {
        			assessment_cycle_id: this.cycle.id,
                    assessment_type: this.assessmentType,
                    [e.target.id]: e.target.value
                }
               
                this.$store.dispatch('general_comment/saveGeneralComment', data)
        		this.$store.dispatch('general_comment/setGeneralCommentElement', {id: e.target.id, value: e.target.value})
            }
        },

        computed: {
            ...mapState({
                cycle: state => state.cycle.cycle,
                generalComment: state => state.general_comment.generalComment,
                submitSuccess: state => state.general_comment.submitSuccess
            })
        },

        mounted () {
            this.$store.dispatch('cycle/setCycle', this.assessmentCycle)
            this.$store.dispatch('general_comment/fetchGeneralComment', {'assessment_cycle_id': this.cycle.id, 'assessment_type': this.assessmentType})
        }
    }
</script>